/* eslint-disable css-modules/no-unused-class, no-nested-ternary */
import { FC } from 'react';
import { Button } from 'learning-panel-components';
import { translate } from 'translations';
import { useSelector } from 'react-redux';
import { selectIsPLG } from '@redux/slices/userSlice';
import styles from './leanBanner.module.scss';

const LeanBanner: FC<{
    setIsContactSupportOpen: Function;
    setContactSupportDefaultValues: Function;
    setIsUpgradeContactSupport: Function;
    translationTextKey: string;
}> = ({
    setIsContactSupportOpen,
    setContactSupportDefaultValues,
    setIsUpgradeContactSupport,
    translationTextKey
}: {
    setIsContactSupportOpen: Function;
    setContactSupportDefaultValues: Function;
    setIsUpgradeContactSupport: Function;
    translationTextKey: string;
}) => {
    const subject = translate('upgradeAccountContactSupportSubject');
    const description = translate('upgradeAccountContactSupportDescription');
    const isPLG = useSelector(selectIsPLG);

    const onContactSupportClick = () => {
        setIsUpgradeContactSupport(true);
        setContactSupportDefaultValues({
            subject,
            description
        });
        setIsContactSupportOpen(true);
    };
    return (
        <div className={styles['lean-banner']}>
            {translate(translationTextKey)}
            {isPLG && (
                <Button
                    type="gradientNoBorder"
                    onClick={onContactSupportClick}
                    text={translate('ContactUs')}
                    lowerCase
                />
            )}
        </div>
    );
};

export default LeanBanner;
